import { useContext } from 'react';
import { CanvasContext } from '../canvas-provider';
const useCanvas = () => {
  return useContext(CanvasContext);
};
export default useCanvas;